import { render, staticRenderFns } from "./ProjectCreateOrEdit.vue?vue&type=template&id=0d4e1a77&scoped=true&"
import script from "./ProjectCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./ProjectCreateOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d4e1a77",
  null
  
)

export default component.exports